import React from "react";
import { useState } from "react";

import { connect } from "react-redux";

import { getManufacturer2 } from "../../redux/actions/manufacturers";
import { addFeaturedMan } from "../../redux/actions/featuredManufacturers";

import ListPageHeader from "../Shared/ListPageHeader";
import SearchDropdown from "../Shared/SearchDropdown";
import OptionsDialog from "./Dialogs/OptionsDialog";

import styles from '../../styles/pages/FeaturedContentPages/ProductCategory.module.css'

const FeaturedManufacturerForm = ({
  addFeaturedMan,
  getManufacturer2,
  manufacturer: { manufacturers, manufacturer, isLoading, success },
  featuredManufacturer: { featuredManufacturers },
}) => {
  const [newManu, setNewManu] = useState({});
  const [disabled, setDisabled] = useState(true);
  const [replaceDialog, openReplaceDialog] = useState(false);
  const [replacementManufacturer, setReplacementManufacturer] = useState(null);
  const [existingFeatureProducts, setExistingFeaturedProducts] = useState([])
  
  const productIndexes = [1, 2, 3]

  const handleManufacturerSelect = async (value) => {
    try {
      const existingFeaturedProduct = featuredManufacturers.length > 0 ? featuredManufacturers.find(e => e.manufacturer_id === +value) : null;

      let existingProduct = {}
      let existingProductOptions = []
      if (existingFeaturedProduct) {

        for (let index of productIndexes) {

          if (existingFeaturedProduct[`product${index}`] && existingFeaturedProduct[`product${index}`].published && existingFeaturedProduct[`expiration_date_${index}`]) {
            existingProduct = {
              ...existingProduct,
              [`product${index}`]: existingFeaturedProduct[`product${index}`].product_id,
              [`expiration${index}`]: existingFeaturedProduct[`expiration_date_${index}`]
            }

            existingProductOptions.push({
              name: existingFeaturedProduct[`product${index}`].name,
              value: existingFeaturedProduct[`product${index}`].product_id,
            })
          }
        }
      }
      
      setNewManu({
        ...existingProduct,
        manufacturerId: value
      })

      setExistingFeaturedProducts([ ...existingProductOptions])

      getManufacturer2(value);
      setDisabled(false);
    } catch (err) {
      console.error(err, "error");
    }
  };

  const handleProductSelect = (name, value) => {
    setNewManu({
      ...newManu,
      manufacturerId: manufacturer.manufacturer_id,
      [name]: value,
    });
  };

  const handleDateSelect = (e) => {
    const { name, value } = e.target;

    setNewManu({
      ...newManu,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    //checks to see if it already exists and attemps to replace it in db
    e.preventDefault();
    if (
      featuredManufacturers.some(
        (manu) => manu.manufacturer_id === newManu.manufacturerId
      )
    ) {
      setReplacementManufacturer(
        featuredManufacturers.filter(
          (manu) => manu.manufacturer_id === newManu.manufacturerId
        )
      );
      openReplaceDialog(true);
    } else {
      //just adds if it doesn't
      addFeaturedMan(newManu);
      setNewManu({});
    }
  };

  const handleClose = (e, closeReason) => {
    e.preventDefault();

    openReplaceDialog(false);

    if (closeReason === 'submitted') {
      setNewManu({})
      setDisabled(true)
    }
  };
  
  return (
    !isLoading &&
    success && (

      <div className={styles.featured_page}>
      
              <ListPageHeader
                title={'Manufacturer Featured Content'}
                description={'Browse and manage all featured content for the Dental Product Shopper manufacturer page.  This page lets you add, edit, or remove featured content.'}            
                
              />
      
      
              <div className={styles.featured_form_card}>
                <div className={`input_container`}>
                    <label>Select Manufacturer</label>
                    <SearchDropdown
                        options={manufacturers ?
                            manufacturers.map(option => ({
                                name: option.name,
                                value: option.manufacturer_id
                            })) 
                        : []} 
                        placeholder={`Select Manufacturer First`} 
                        handleSelect={(option) => handleManufacturerSelect(option)}
                        emptyOption={"No Options"}
                        selection={newManu?.manufacturerId ? newManu.manufacturerId : null}
                    />
      
                </div>
                {productIndexes.map(index => (

                  <div key={`product-${index}`} className={styles.featured_form_card_input_row}>
                    <div className={`input_container`}>
                        <label>Search for a product</label>
                        <SearchDropdown
                            options={[
                                ...existingFeatureProducts,

                                ...manufacturer && manufacturer.Products ?
                                  manufacturer.Products.map(option => ({
                                      name: option.name,
                                      value: option.product_id,
                                  })) 
                                : []
                            ]} 
                            disabled={disabled}
                            placeholder={`Start typing to search product`} 
                            handleSelect={(option) => handleProductSelect(`product${index}`, option)}
                            // handleSearch={value => searchForProducts(value)}
                            emptyOption={"No Options"}
                            selection={newManu[`product${index}`] ? newManu[`product${index}`]  : null}
                        />
        
                    </div>
                    
                    <div className={'input_container'}>
                      <label>Expiration Date</label>
                      <input
                        type='date'
                        className={'input_basic input_date'}
                        disabled={disabled}
                        value={newManu[`expiration${index}`] ? newManu[`expiration${index}`].slice(0, 10) : ''}
                        name={`expiration${index}`}
                        onChange={handleDateSelect}
                      />
                    </div>
        
                  </div>
                ))}
          
                <div>
                  <hr />
                  <div className={styles.featured_form_button_container}>
                    <button className={`${styles.featured_button}`} onClick={(e) => handleSubmit(e)}
                        disabled={
                          !(
                            newManu.manufacturerId &&
                            (newManu.product1 && newManu.expiration1) ||
                            (newManu.product2 && newManu.expiration2) ||
                            (newManu.product3 && newManu.expiration3)
                          )
                        }>Submit</button>
      
                  </div>
                </div>
              </div>
              <OptionsDialog
                open={replaceDialog}
                handleClose={handleClose}
                selectedAction={'replaceConfirm'}
                newManu={newManu}
                replacementManufacturer={replacementManufacturer}
              />
            </div>
    )
  );
};

const mapStateToProps = (state) => ({
  manufacturer: state.manufacturer,
  featuredManufacturer: state.featuredManufacturer,
});

export default connect(mapStateToProps, { getManufacturer2, addFeaturedMan })(
  FeaturedManufacturerForm
);
